export const getPermissions = () => {
  try {
    const perms = JSON.parse(sessionStorage.getItem('permissions') || '[]');
    return perms;
  } catch {
    return [];
  }
};

export const getPermissionForModule = (moduleName) => {
  const role = sessionStorage.getItem("role");
  if (role !== "Staff") {
    return {
      canView: true,
      canAdd: true,
      canEdit: true,
      canDelete: true,
    };
  }

  const perms = getPermissions();
  return perms.find(p => p.moduleName === moduleName) || {};
};
